var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('v-container',{attrs:{"fill-height":""}},[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"cols":"auto"}},[_c('h2',[_vm._v("403 Not authorized for this application")])])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }